import parameterService from './parameterService';
import paymentTypeService from './paymentTypeService';
const paymentTypes = paymentTypeService.getPaymentTypes();

class PaymentService {
    constructor() {
        this.paygate = '';
    }

    formPost(path, params) {
        // The rest of this code assumes you are not using a library.
        // It can be made less wordy if you use one.
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', path);

        for(let key in params) {
            if (params.hasOwnProperty(key)) {
                let hiddenField = document.createElement('input');
                hiddenField.setAttribute('type', 'hidden');
                hiddenField.setAttribute('name', key);
                hiddenField.setAttribute('value', params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }

    sendExternalPaymentRequest(interfaceUrl, parameters) {
        this.formPost(interfaceUrl, parameters);
    }

    postAsFormData(url, data) {

        // Computop Paygate URL
        let paymentMethodSource = "/payssl.aspx";

        if (window.location.pathname.includes("paymentPage.aspx")) {
            paymentMethodSource = "/paymentPage.aspx";
        }

        url = url + paymentMethodSource;

        const formData  = new FormData();

        for(let key in data) {
            formData.append(key, data[key]);
        }

        return fetch(url, {
            method: 'POST',
            body: formData,
        });
    }

    createAndSubmit3DS1Form(acsUrl, termUrl, paReq) {
        var form = document.createElement('form');
        form.method = "POST";
        form.target = '_self';
        form.action = acsUrl;
    
        document.querySelector('body').appendChild(form);
    
        var md = this.create_hidden_field("MD", "");
        form.appendChild(md);
        var paReq = this.create_hidden_field("PaReq", paReq);
        form.appendChild(paReq);
        var termUrl = this.create_hidden_field("TermUrl", termUrl);
        form.appendChild(termUrl);
    
        form.submit();
    }
    
    create_hidden_field(key, value) {
        var field = document.createElement("input");
        field.setAttribute("type", "hidden");
        field.setAttribute("name", key);
        field.setAttribute("value", value);
    
        return field;
    }
    
    getBinfo() {
        var javaEnabled = navigator.JavaEnabled ? true : false;
        var colorDepth = window.screen.colorDepth;
        var screenHeight = window.innerHeight;
        var screenWidth = window.innerWidth;
        var userAgent = navigator.userAgent;
        var timeZoneOffset = new Date().getTimezoneOffset();
        return "javaEnabled=" + javaEnabled + "&colorDepth=" + colorDepth + "&screenHeight=" + screenHeight + "&screenWidth=" + screenWidth + "&timeZoneOffset=" + timeZoneOffset + "&userAgent=" + userAgent;
    }
    
    get3DS2Url(versioningData) {
        var url = parameterService.googlePayData.GooglePayPostURL + "3DS2.aspx?versioningData=" + versioningData;
        url += "&redirectType=POST";
    
        return url;
    }

    creditCardPayment(cardCredentials, variationName) {
        let computopInterface = 'payinterim.aspx';
        let parameters = {};
        let paygate = Object.assign({}, parameterService.getPaygateData());

        if (variationName === 'pay2' || variationName === 'pay2_test' ||variationName === 'pay2_ct' || variationName === 'pay2_ct_test' ||variationName === 'pay2_1cs' || variationName === 'pay2_1cs_test') {
            computopInterface = 'paynow.aspx';
            parameters = {
                ...paygate,
                'CCNr': cardCredentials.cardNumber.replace(/\s/g, ''),
                'CCExpiry': (cardCredentials.expYear.length === 2 ? '20' : '') + cardCredentials.expYear + (cardCredentials.expMonth[1] ? '' : '0') + cardCredentials.expMonth,
                'CCCVC': cardCredentials.checkNumber,
                'CCBrand': cardCredentials.brand.replace('CC_', ''),
                'CreditCardHolder': cardCredentials.cardHolder
            };
        } else {
            /* @todo find a better way to exclude the browserInfo for payinterim calls */
            delete paygate.browserInfo;

            parameters = {
                ...paygate,
                'cardNumber': cardCredentials.cardNumber.replace(/\s/g, ''),
                'cardExpirationMonth': (cardCredentials.expMonth[1] ? '' : '0') + cardCredentials.expMonth,
                'cardExpirationYear': (cardCredentials.expYear.length === 2 ? '20' : '') + cardCredentials.expYear,
                'cccvc': cardCredentials.checkNumber,
                'KKName': cardCredentials.brand.replace('CC_', ''),
                'CreditCardHolder': cardCredentials.cardHolder,
                'prefill': cardCredentials.saveCardNumber
            };
        }

        this.sendExternalPaymentRequest(computopInterface, parameters);
    }

    directDebitPayment(debitCredentials) {
        const computopInterface = 'paySDD.aspx' + window.location.search;
        const parameters = {
            ...parameterService.paygate,
            'AccOwner': debitCredentials.accountOwner,
            'IBAN': debitCredentials.iban
        };
        this.sendExternalPaymentRequest(computopInterface, parameters);
    }

    onLoadGooglePaymentData(paymentData) {
        this.postAsFormData(
            parameterService.googlePayData.GooglePayPostURL,
            {
                MerchantID: parameterService.paygate.MerchantID,
                Len: parameterService.paygate.Len,
                Data: parameterService.paygate.Data,
                TokenExt: paymentData.paymentMethodData.tokenizationData.token,
                PT: 'GooglePay',
                PaymentMethod: 'GooglePay',
                binfo: this.getBinfo()
            }
        ).then(response => response.text()
        ).then(response => {
            response = response.split('|');

            if (response[1] === 'success') {
                // Evaluate success case with GooglePay API
            } else if (response[1] == "3ds1") {
                var jsonString = window.atob(response[0]);
                var json = JSON.parse(jsonString);
    
                var acsUrl = json.acsUrl;
                var paReq = json.paReq;
                var termUrl = json.termUrl;
    
                this.createAndSubmit3DS1Form(acsUrl, termUrl, paReq);
                return false;
            }
            else if (response[1] == "3ds2") {
                var url = this.get3DS2Url(response[0]);
    
                window.location = url;
                return false;
            }

            // Redirect to success/failure url
            setTimeout(() => {
                window.location.replace(response[0]);
            }, 3000);
        }).catch(error => console.error(error));
    }

    applePayPayment() {
        const url = parameterService.getHiddenInputValue('ApplePayPostURL');
        // Only version 10 supports giropay
        const apiVersion = window.ApplePaySession.supportsVersion(10) ? 10 : 9;

       	// Create ApplePay session
       	const session = new window.ApplePaySession(apiVersion, parameterService.getApplePaymentRequest());
        const data = {
            ...parameterService.paygate,
            ...parameterService.applePayData,
            'PaymentMethod': 'ApplePay',
        };
       	// Validate merchant via server request
       	session.onvalidatemerchant = (event) => {
       		// Set ApplePay payment method and ApplePay validationUrl for the first server request
            data.ApplePayValidationURL = event.validationURL;
            // Evaluate merchant validation server request
            this.postAsFormData(url, data)
                .then(response => response.text())
                .then(text => {
                    text = text.split('|');

                if (text.length === 3) {
                    data.ApplePayPayID = text[1];
                    session.completeMerchantValidation(JSON.parse(text[0]));
                } else {
                    // Redirects to failure url
                    window.location.replace(text[0]);
                }
            }).catch(error => console.error(error));
       	};

       	// An event handler that is called when the user has authorized the Apple Pay payment with Touch ID, Face ID, or passcode
       	session.onpaymentauthorized = (event) => {
       		// Set ApplePay payment token for the second server request
            data.ApplePayPaymentToken = JSON.stringify(event.payment.token);

            this.postAsFormData(url, data)
                .then(response => response.text())
                .then(text => {
                // Evaluate payment authorization server request
                    text = text.split('|');

           	    const applePayStatus = text[1] === 'success' ? window.ApplePaySession.STATUS_SUCCESS : window.ApplePaySession.STATUS_FAILURE;

           	    session.completePayment(applePayStatus);

                // Redirects to success/failure url
                setTimeout(() => {
                    window.location.replace(text[0]);
                }, 3000);
            }).catch(error => console.error(error));
       	};

       	// Evaluation, if customer clicks "Abort" on apple pay payment sheet
       	session.oncancel = (event) => {
       		console.log(event);
       	};

       	session.begin();
    }

    forwardToExternal(paymentProvider) {
        const matchingPaymentTypes = paymentTypes.filter(ele => ele.type === paymentProvider);
        let paymentApiType = paymentProvider;
        if (matchingPaymentTypes.length > 0) {
            paymentApiType = matchingPaymentTypes[0].apiType
        }
        const computopInterface = 'paymentpage.aspx' + window.location.search;
        const parameters = {
            ...parameterService.paygate,
            'PaymentMethod': paymentApiType, //example: 'PayPal'
            'CreditCardBrand': '',
            'paymentMethodRadio': ''
        };
        this.sendExternalPaymentRequest(computopInterface, parameters);
    }
}

export default new PaymentService();



// WEBPACK FOOTER //
// ./src/services/paymentService.js